import { CustomRouteConfig } from "@/models/plugins/CustomRouterTypes";
import PERMISSIONS from "@/static/permissions";

export enum REPORTS_ROUTE_NAMES {
  reports = "Reports",
  reportsGenerator = "Reports Generator",
  automaticReports = "Automatic Reports",
  reportsBSP = "Reports BSP",
  bookingReports = "Booking Reports",
}

const ReportsRoutes: Array<CustomRouteConfig> = [
  {
    name: REPORTS_ROUTE_NAMES.reports,
    path: "reports",
    component: () => import(/* webpackChunkName: "reports" */ "@/views/reports/ReportsView.vue"),
    redirect: { name: REPORTS_ROUTE_NAMES.reportsGenerator },
    children: [
      {
        name: REPORTS_ROUTE_NAMES.reportsGenerator,
        path: "generator",
        meta: { hasOneOfPermissions: [PERMISSIONS.ReportsRead] },
        component: () => import(/* webpackChunkName: "reports" */ "@/views/reports/ReportsGeneratorView.vue"),
      },
      {
        name: REPORTS_ROUTE_NAMES.automaticReports,
        path: "automatic-reports",
        component: () => import(/* webpackChunkName: "reports" */ "@/views/reports/AutomaticReportsView.vue"),
      },
    ],
  },
  {
    name: REPORTS_ROUTE_NAMES.reportsBSP,
    path: "reports-BSP",
    component: () => import(/* webpackChunkName: "reports" */ "@/views/reports/ReportsBSPView.vue"),
    meta: { hasOneOfPermissions: [PERMISSIONS.ReportsBSPRead] },
  },
  {
    name: REPORTS_ROUTE_NAMES.bookingReports,
    path: "booking-reports",
    component: () => import(/* webpackChunkName: "reports" */ "@/views/reports/BookingReportsView.vue"),
    meta: { hasOneOfPermissions: [PERMISSIONS.BookingReportsRead] },
  },
];

export { ReportsRoutes };
export default ReportsRoutes;
